/*
 * We need the icons to be inline SVG's to get the currentColor to be the text color especially for rollover states.
 * Ideally the icons only exist as SilverStripe .ss template files in the icon folder.
 * These icons also need to be added by JavaScript when it is building html blocks.
 * No Tailwind classes allowed in here, as they will not be recognized by Tailwinds class purge.
 */
export default class Icons {
  accordionArrow() {
    return `<svg
    class="icon"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 10 6"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M9 5 5 1 1 5"
    ></path>
  </svg>
  `;
  }

  currentFilterX() {
    return `<svg
      class="icon"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
      />
    </svg>
    `;
  }

  infrastructure() {
    return `<svg
      class="icon"
      viewBox="0 0 14 15"
      xmlns="http://www.w3.org/2000/svg"
      enable-background="new 0 0 14 15"
      xml:space="preserve"
    >
      <path fill="currentColor" d="M2.333,7.208v2.333c0,0.484,0.391,0.875,0.875,0.875c0.484,0,0.875-0.391,0.875-0.875V7.208
    c0-0.484-0.391-0.875-0.875-0.875C2.724,6.333,2.333,6.724,2.333,7.208z M5.833,7.208v2.333c0,0.484,0.391,0.875,0.875,0.875
    c0.484,0,0.875-0.391,0.875-0.875V7.208c0-0.484-0.391-0.875-0.875-0.875C6.224,6.333,5.833,6.724,5.833,7.208z M2.042,13.333h9.333
    c0.484,0,0.875-0.391,0.875-0.875c0-0.484-0.391-0.875-0.875-0.875H2.042c-0.484,0-0.875,0.391-0.875,0.875
    C1.167,12.942,1.558,13.333,2.042,13.333z M9.333,7.208v2.333c0,0.484,0.391,0.875,0.875,0.875c0.484,0,0.875-0.391,0.875-0.875
    V7.208c0-0.484-0.391-0.875-0.875-0.875C9.724,6.333,9.333,6.724,9.333,7.208z M6.166,1.369L1.558,3.796
    C1.318,3.918,1.167,4.169,1.167,4.437c0,0.403,0.327,0.729,0.729,0.729h9.631c0.397,0,0.723-0.327,0.723-0.729
    c0-0.268-0.152-0.519-0.391-0.642L7.251,1.369C6.913,1.188,6.504,1.188,6.166,1.369L6.166,1.369z" />
    </svg>
    `;
  }

  resource() {
    return `<svg
      class="icon"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      xml:space="preserve"
      >
      <path fill="currentColor" d="M10.6258 4.37076L8.52584 5.35076L7.16667 3.99159V3.17492L8.52584 1.81576L10.6258 2.79576C10.8475
      2.90076 11.1042 2.80159 11.2092 2.58576C11.3142 2.36409 11.215 2.10742 10.9992 2.00242L8.71251 0.934922C8.49084 0.829922 8.22834
      0.876589 8.05334 1.05159L7.03834 2.06659C6.93334 1.92659 6.77001 1.83326 6.58334 1.83326C6.26251 1.83326 6.00001 2.09576 6.00001
      2.41659V2.99992H4.14501C3.86501 2.21826 3.06001 1.68742 2.15001 1.86826C1.46751 2.00242 0.907506 2.56242 0.779173 3.24492C0.633339
      4.02659 1.01251 4.72659 1.61334 5.08826L3.13001 9.99992H2.20834C1.72417 9.99992 1.33334 10.3908 1.33334 10.8749C1.33334 11.3591 1.72417
      11.7499 2.20834 11.7499H8.04167C8.52584 11.7499 8.91667 11.3591 8.91667 10.8749C8.91667 10.3908 8.52584 9.99992 8.04167 9.99992H6.80501L3.90584
      4.61576C4.00501 4.47576 4.08667 4.32992 4.14501 4.16659H6.00001V4.74992C6.00001 5.07076 6.26251 5.33326 6.58334 5.33326C6.77001 5.33326
      6.93334 5.23992 7.03834 5.09992L8.05334 6.11492C8.22834 6.28992 8.49084 6.33659 8.71251 6.23159L10.9992 5.16409C11.2208 5.05909 11.3142
      4.80242 11.2092 4.58076C11.1042 4.36492 10.8475 4.26576 10.6258 4.37076ZM2.50001 4.16659C2.17917 4.16659 1.91667 3.90409 1.91667 3.58326C1.91667
      3.26242 2.17917 2.99992 2.50001 2.99992C2.82084 2.99992 3.08334 3.26242 3.08334 3.58326C3.08334 3.90409 2.82084 4.16659 2.50001 4.16659Z" />
    </svg>`;
  }

  infoCircle() {
    return `<svg
        class="icon"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 21 21"
      >
        <path
          d="M9.5,5.5h2v2h-2v-2ZM10.5,15.5c.6,0,1-.4,1-1v-4c0-.6-.4-1-1-1s-1,.4-1,1v4c0,.6.4,1,1,1ZM10.5.5C5,.5.5,5,.5,10.5s4.5,10,10,10,10-4.5,10-10S16,.5,10.5.5ZM10.5,18.5c-4.4,0-8-3.6-8-8S6.1,2.5,10.5,2.5s8,3.6,8,8-3.6,8-8,8Z"
          fill="currentColor"
        />
      </svg>`;
  }

  // This also exists in includes/Spinner.ss so its tailwind classes are found there.
  spinner() {
    return `<div class="spinner" role="status">
      <svg
        class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-kitmap-teal"
        aria-hidden="true"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        />
      </svg>
      <span class="sr-only">Loading...</span>
    </div>`;
  }
}
